/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Style from './EmprestimoGarantiaCarroSaber.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function EmprestimoGarantiaCarroSaber() {
  return (
    <>
      <section id="emp-garantia-carro-saber">
        <ContainerHome24>
          <div className="saber-conteudo">
            <h3 className="saber-titulo">
              O que você precisa saber para oferecer seu carro como garantia
            </h3>
            <div className="saber-itens">
              <p className="saber-item">
                <b>1.</b> Seu carro deve estar quitado, regularizado (sem multas ou restrições no
                documento do veículo) e ter no máximo 20 anos (a partir de 2006);
              </p>
              <p className="saber-item">
                <b>2.</b> O carro tem que estar no nome do solicitante do empréstimo;
              </p>
              <p className="saber-item">
                <b>3.</b> Quanto mais novo o modelo do carro, melhores as condições de empréstimo.
              </p>
            </div>
          </div>
          <div className="saber-card">
            <h4 className="saber-card-titulo">Fique atento</h4>
            <p className="saber-card-texto">
              Depois que o empréstimo for aprovado e o dinheiro depositado na sua conta, você terá
              30 dias para ir ao Detran, onde seu veículo foi registrado, e reemitir o documento.
            </p>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroSaber;
